/**
 * variety Normalizr Schema
 */

import { schema } from 'normalizr';

const variety = new schema.Entity('varieties');

export default variety;
